// @todo: Migrate to 'Icon' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Icon} from '@wandb/weave/components/Icon';
import {Tailwind} from '@wandb/weave/components/Tailwind';
// @todo: Migrate to 'Tooltip' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Tooltip} from '@wandb/weave/components/Tooltip';
import React, {useEffect, useState} from 'react';

import {TraversalDirection} from '../../generated/graphql';
import {TruncatedText} from '../TruncatedText';
import {InstrumentedLoader as Loader} from '../utility/InstrumentedLoader';
import {DAG_REQUEST_LIMIT} from './ArtifactDag';
import {artifactMembershipNodeInputType} from './InfoDrawerArtifacts';
// eslint-disable-next-line import/no-cycle -- please fix if you can
import {extractArtifactMembershipNodeInput, nodeType} from './LayoutDagUtils';
import {useArtifactDagQueryCaller} from './queries/artifactDag.query';
import {Artifact, Cluster, Dag, TOWARD_ARTIFACT} from './utils';

type ClusterArtifactNodeProps = {
  artifactNode: Artifact;
  updateDag: (
    newDag: Dag,
    expandedArtifact: string,
    expandedRun: string
  ) => void;
  setIsDrawerOpen: (val: boolean) => void;
  setDrawerType: (val: nodeType) => void;
  setArtifactMembershipNodeInput: (
    val: artifactMembershipNodeInputType
  ) => void;
  filterGeneratedArtifacts: boolean;
  cluster: Cluster;
  clusterSize?: number;
  directLineage: boolean;
};

export const ClusterArtifactNode = ({
  artifactNode,
  updateDag,
  setIsDrawerOpen,
  setDrawerType,
  setArtifactMembershipNodeInput,
  filterGeneratedArtifacts,
  clusterSize,
  directLineage,
  cluster,
}: ClusterArtifactNodeProps) => {
  const [dagQueryInput, setDagQueryInput] = useState({
    artifactVersionID: '',
    artifactCommitHash: '',
    limit: DAG_REQUEST_LIMIT,
    filterGeneratedArtifacts,
    clusterSize,
    directLineage,
  });

  const clusterEdge =
    cluster.clusterEdges.length > 0 ? cluster.clusterEdges[0] : null;
  const clusterEdgeDir =
    clusterEdge != null
      ? clusterEdge.direction.toString() === TOWARD_ARTIFACT
        ? TraversalDirection.Downstream
        : TraversalDirection.Upstream
      : undefined;

  const baseGraphRunNodes = cluster.clusterEdges.map(n => n.runNodeID);

  const newDag = useArtifactDagQueryCaller(
    dagQueryInput.artifactVersionID,
    dagQueryInput.artifactCommitHash,
    dagQueryInput.limit,
    dagQueryInput.filterGeneratedArtifacts,
    dagQueryInput.clusterSize,
    dagQueryInput.directLineage,
    clusterEdgeDir,
    baseGraphRunNodes
  );

  useEffect(() => {
    if (dagQueryInput.artifactVersionID === '') {
      return;
    }
    if (!newDag.loading && newDag.dag != null) {
      updateDag(newDag.dag, artifactNode.artifactNodeID, '');
    }
  }, [
    dagQueryInput.artifactVersionID,
    newDag.loading,
    newDag.dag,
    artifactNode.artifactNodeID,
    updateDag,
  ]);

  if (newDag.loading) {
    return (
      <Loader name="lineage-dag-cluster-artifact-node" inline size="tiny" />
    );
  }

  return (
    <>
      <Tailwind style={{width: '100%'}}>
        <div className="group flex w-full items-center justify-between px-[10px] py-[6px]">
          <div
            className="w-full"
            onClick={() => {
              setIsDrawerOpen(true);
              setDrawerType(nodeType.ARTIFACT);
              setArtifactMembershipNodeInput(
                extractArtifactMembershipNodeInput(artifactNode)
              );
            }}>
            <TruncatedText>
              {artifactNode?.artifactSequenceName +
                ':v' +
                artifactNode?.versionIndex}
            </TruncatedText>
            <div className="text-[13px] font-normal text-moon-650">
              <TruncatedText>{artifactNode.artifactTypeName}</TruncatedText>
            </div>
          </div>

          <Tooltip
            content={'Break out'}
            position="bottom center"
            trigger={
              <Icon
                name="log-out"
                onClick={() => {
                  setDagQueryInput({
                    ...dagQueryInput,
                    ...artifactNode,
                    artifactVersionID: artifactNode.id,
                  });
                }}
                className="invisible h-[16px] w-[16px] group-hover:visible"
              />
            }></Tooltip>
        </div>
      </Tailwind>
    </>
  );
};
